import { ThemeProvider } from "@emotion/react";
import { Paper, createTheme } from "@mui/material";
import React from "react";

const wezpiTheme = createTheme();

export default function Contactanos() {
  return (
    <ThemeProvider theme={wezpiTheme}>
      <div className="container">
        <Paper elevation={3} className="contactanos">
          <h3> Contáctanos </h3>
          <p>
              Tienes alguna sugerencia o comentario, escríbenos al correo:
          </p>
          <a href="mailto:contacto@wezpi.com">
            contacto@wezpi.com
          </a>
          <p>
            o escríbenos a nuestro WhatsApp:
          </p>
          <a href="https://wa.me/3160571218">
              +57 316 057 12 18
          </a>
        </Paper>
      </div>
    </ThemeProvider>
  );
};
